<template>
   <div class="container" v-if="mainPageContents">
      <div id="dark" @click="darkScreen('off', 'all')"></div>
      <div id="login-window">
         <div id="login-form">
            <h1 id="loginTitle">כניסה לחברות ניהול</h1>
            <form @submit.prevent="login">
               <input
                  class="login-input"
                  type="email"
                  name="email"
                  placeholder='דוא"ל'
                  required
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  v-model="loginEmail"
                  ref="email"
               />
               <input
                  class="login-input"
                  type="password"
                  name="password"
                  :placeholder="this.$t('password')"
                  v-model="loginPassword"
               />
               <div id="login-confirmation">
                  <input
                     id="login-checkbox"
                     type="checkbox"
                     v-model="termsAccepeted"
                  />
                  <p>הנני מאשר את</p>
                  <p
                     class="termsConfirmation"
                     style="color: #ff6813"
                     @click="
                        darkScreen('off', '#login-window')
                        togglePage('isTermsPage')
                     "
                  >
                     תנאי השימוש
                  </p>
               </div>

               <div id="login-submit">
                  <input type="submit" :value="this.$t('loginToSystem')" />
                  <center id="loginHelp">
                     <div
                        @click="
                           darkScreen('off', '#login-window')
                           goToContact()
                        "
                        id="newUserLink"
                     >
                        צור קשר
                     </div>
                     <p style="display: inline-block; color: white">|</p>
                     <div id="forgotPassword" @click="resetPassword()">
                        שכחתי סיסמה
                     </div>
                  </center>
               </div>
            </form>
         </div>
         <div id="login-logo">
            <img src="/static/gfx/Login_illus.svg" alt="LoginLogo" />
         </div>
         <div id="login-image">
            <img src="/static/gfx/loginGuy.svg" alt="LoginImage" srcset="" />
         </div>
      </div>
      <header class="mainHeader">
         <div
            style="grid-column: 3; cursor: pointer"
            @click="togglePage('isMainPage')"
         >
            <img
               src="/static/gfx/oxsNewLogo.svg"
               class="oxsLogo"
               alt="logo"
               srcset=""
            />
         </div>
         <div class="loginButton" style="cursor: pointer">
            <p @click="darkScreen('on', '#login-window')">כניסה לחברות ניהול</p>
         </div>
      </header>
      <div class="mainPage" v-if="togglePages.isMainPage">
         <section id="mainContent">
            <div class="firstTab">
               <div id="textFirstTab" v-html="mainPageContents.maintitle"></div>
            </div>
            <div class="secondTab">
               <div class="imageContainer">
                  <img
                     src="/static/gfx/mobileView.png"
                     alt="mobileView"
                     style="image-rendering: pixelated"
                  />
               </div>
               <div class="tableGrid" v-if="section2Contents">
                  <div id="headline" v-html="section2Contents.content1"></div>
                  <div id="listContainer">
                     <table>
                        <tbody v-for="(item, i) in listItems" :key="i">
                           <hr :class="{ orangeBorder: showList == i }" />
                           <div id="list" @click="openExpendable(i)">
                              <td id="listItem" v-html="item.headline"></td>
                              <img
                                 :class="{ rotate180: showList != i }"
                                 src="/static/gfx/chevronUp.svg"
                                 alt="upArrow"
                              />
                           </div>
                           <div
                              :class="showList == i ? 'openList' : 'closeList'"
                           >
                              <td id="listContent" v-html="item.content"></td>
                           </div>
                        </tbody>
                        <hr />
                     </table>
                  </div>
               </div>
            </div>
            <div class="seperator">
               <img src="/static/gfx/seperator.svg" alt="seperator" />
            </div>
            <div class="carouselTab">
               <carousel
                  :loop="!isMobile ? true : false"
                  :autoplay="true"
                  :centerMode="true"
                  :direction="ltr"
                  :autoplayTimeout="6000"
                  :navigationEnabled="false"
                  :perPage="1"
                  :paginationActiveColor="'#ff6813 !important'"
                  :speed="1500"
                  class="carouselDescription"
               >
                  <slide v-html="section3Contents.content1"> </slide>
                  <slide v-html="section3Contents.content2"></slide>
                  <slide v-html="section3Contents.content3"></slide>
               </carousel>
            </div>
         </section>
      </div>
      <div class="aboutTab" v-if="togglePages.isAboutPage">
         <div class="aboutTab" v-html="mainPageContents.about"></div>

         <div class="imageContainer">
            <img src="/static/gfx/aboutPage.svg" srcset="" alt="isAboutPage" />
         </div>
      </div>
      <div
         v-if="togglePages.isPrivacyPage"
         class="privacyPage"
         v-html="mainPageContents.privacy"
      ></div>
      <div
         v-if="togglePages.isTermsPage"
         class="termsPage"
         v-html="mainPageContents.terms"
      ></div>
      <section v-if="togglePages.isCareersPage" id="careerSection">
         <div class="careersTab">
            <div class="textContainer" v-html="mainPageContents.careers"></div>
            <div class="imageContainer">
               <img
                  src="/static/gfx/Career.png"
                  alt="carrerImage"
                  srcset=""
                  style="width: auto"
               />
            </div>
         </div>
         <div class="careerCards">
            <section class="cards">
               <article class="card" v-for="(career, i) in careers" :key="i">
                  <div v-html="career.headline"></div>
                  <button
                     class="whiteBackground"
                     @click=";(showModal = i), (position = career.headline)"
                  >
                     Apply
                  </button>
                  <uiModal
                     v-if="showModal === i"
                     @closeModal="showModal = false"
                     id="careerModal"
                  >
                     <template slot="header">
                        <center>
                           <section
                              class="applicationModalText"
                              v-html="career.headline"
                           ></section>
                        </center>
                     </template>
                     <template slot="body">
                        <table id="positionTextTable">
                           <tr>
                              <td
                                 class="applicationModalText"
                                 v-html="career.content"
                              ></td>
                              <td>
                                 <img
                                    id="positionImage"
                                    src="/static/gfx/Career2.png"
                                    alt=""
                                 />
                              </td>
                           </tr>
                        </table>
                     </template>
                     <template slot="footer">
                        <form
                           @submit.prevent="sendResume"
                           enctype="multipart/form-data"
                        >
                           <label for="custom-file-input" id="resumeLabel"
                              >Upload resume</label
                           >
                           <img
                              v-if="!uplodaingFile && !isResumeUploaded"
                              src="/static/gfx/Vector.svg"
                              alt=""
                              class="resumeImage"
                           />
                           <img
                              v-if="uplodaingFile && !isResumeUploaded"
                              src="/static/gfx/cloud_100.gif"
                              alt=""
                              class="resumeImage"
                           />
                           <img
                              v-if="isResumeUploaded"
                              src="/static/gfx/waV.svg"
                              alt=""
                              class="resumeImage"
                           />
                           <input
                              type="file"
                              ref="file"
                              id="custom-file-input"
                              :v-model="resume"
                              @change="uploadResume"
                           />
                           <textarea
                              id="candidateComments"
                              placeholder="Anything else you want to share?"
                              v-model="applicationContent"
                           ></textarea>
                           <table id="positionFormTable">
                              <tr>
                                 <td>
                                    <button
                                       id="positionCancelButton"
                                       class="modalButton"
                                       type="button"
                                       @click="showModal = false"
                                    >
                                       Cancel
                                    </button>
                                 </td>
                                 <td>
                                    <button type="submit" class="modalButton">
                                       Submit Application
                                    </button>
                                 </td>
                              </tr>
                           </table>
                        </form>
                     </template>
                  </uiModal>
               </article>
               <div id="applicSubModal" v-if="isApplicationSubmitted">
                  <h1>Thank You For Your Application!</h1>
                  <div
                     id="applSubClose"
                     @click="
                        darkScreen('off', '#applicSubModal')
                        isApplicationSubmitted = false
                     "
                  >
                     <h2>Close</h2>
                  </div>
               </div>
            </section>
         </div>
      </section>
      <section v-if="togglePages.isPublicComplaintsPage" id="publicComplaintSection">
         <div class="careersTab publicComplaintTab">
            <div class="textContainer">
               <h1>פנייה לממונה תלונות הציבור</h1>
               <p class="subHeaderText">
                  יש לכם תלונה, דברי שבח או הצעה ?
                  יחידת פניות הציבור ב OXS לשירותכם
                  ניתן להגיש את הפנייה באחת משתי הדרכים הבאות:
               </p>
               <div class="publicComplaints">
                  <div class="publicComplaintsItemRoundBlock">
                     <div class="publicComplaintsItemBlock">
                        <a href="mailto:public@oxs.co.il">
                           <div class="publicComplaintsItem">
                              <img
                                 src="/static/gfx/bluemessages.svg"
                                 alt="phone"
                                 srcset=""
                              />
                           </div>
                           <div class="boxHeader">
                              <span>כתובת מייל ייעודית ליחידת פניות הציבור</span>
                           </div>
                           <div class="boxSubText">
                              <span>public@oxs.co.il</span>
                           </div>
                        </a>
                     </div>
                     <div class="publicComplaintsItemBlock">
                        <div class="publicComplaintsItem">
                           <img
                              src="/static/gfx/bluebuilding.svg"
                              alt="phone"
                              srcset=""
                           />
                        </div>
                        <div class="boxHeader">
                           <span>פנייה באמצעות דואר</span>
                        </div>
                        <div class="boxSubText">
                           <span>רח' הכישור 47, חולון, מיקוד 5886709</span>
                        </div>
                     </div>
                  </div>
                  <div class="publicComplaintsItemBox">
                     <div class="publicComplaintsItem">
                        <div class="boxHeader">
                           <span>לצורך טיפול יעיל בפנייתך יש לכלול בגוף הפנייה את הפרטים הבאים:</span>
                        </div>
                        <div class="boxSubText">
                           <span>
                              שם הפונה, שם החברה, כתובת, מס' טלפון, תיאור פרטי הפנייה
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      <div class="connectTab">
         <section class="connect" v-if="!msgSentSuccess">
            <div class="headline">
               <p>{{ $t('doYouHaveQuestions') }}</p>
               <h2 style="font-size: 25px">{{ $t('contactUs') }}</h2>
            </div>
            <div class="connectForm">
               <input
                  :class="{ redBorder: showError && nameError }"
                  v-model="name"
                  class="inputText"
                  type="text"
                  required
               />
               <span :class="{ hasInput: name != '' }" class="floating-label"
                  >שם מלא</span
               >

               <input
                  :class="{ redBorder: showError && phoneError }"
                  v-model="phone"
                  class="inputText"
                  type="text"
                  required
               />
               <span
                  :class="{ hasInput: phone != '' }"
                  class="floating-label"
                  >{{ $t('phone') }}</span
               >

               <input
                  :class="{ redBorder: showError && emailError }"
                  v-model="email"
                  class="inputText"
                  type="text"
                  required
               />
               <span
                  :class="{ hasInput: email != '' }"
                  class="floating-label"
                  >{{ $t('email') }}</span
               >

               <input v-model="reason" class="inputText" type="text" required />
               <span :class="{ hasInput: reason != '' }" class="floating-label">
                  {{ $t('contactReason') }}
               </span>

               <select :name="$t('position')" id v-model="info">
                  <option value="none" selected disabled>
                     {{ $t('choosePosition') }}
                  </option>
                  <option :value="$t('tenant')">{{ $t('tenant') }}</option>
                  <option :value="$t('buildingFees')">
                     {{ $t('buildingFees') }}
                  </option>
                  <option :value="$t('mngCompany')">
                     {{ $t('mngCompany') }}
                  </option>
               </select>

               <button
                  :disabled="isSendDisabled"
                  @click="requestJoin()"
                  class="normal connectBtn"
               >
                  צרו קשר
               </button>
               <center>
                  <div
                     :style="showError ? 'display:block' : 'display:none'"
                     id="error"
                  >
                     השדות באדום אינם תקינים
                  </div>
               </center>
            </div>
            <div class="imageContainer">
               <img src="/static/gfx/contact_illus.svg" alt="building" />
            </div>
         </section>
         <div class="msgSent" v-else></div>
      </div>
      <div class="fifthTab">
         <div class="headlines" v-html="mainPageContents.appstitle"></div>
         <div class="appStore">
            <a target="_" :href="iosLink">
               <img
                  src="/static/gfx/appleStore.svg"
                  alt="appleStore"
                  srcset=""
               />
            </a>
            <a target="_" :href="androidLink">
               <img src="/static/gfx/google.svg" alt="android" srcset="" />
            </a>
         </div>
         <div
            v-if="!isMobile"
            class="imageContainer"
            v-tippy
            :title="'הפעלת תפריט נגישות'"
         >
            <img
               src="/static/gfx/accessibility.svg"
               alt=""
               @click="startAccessibility()"
            />
         </div>
      </div>
      <hr />
      <footer class="footer">
         <ul class="nav">
            <li @click="togglePage('isMainPage')">
               <img
                  src="/static/gfx/oxsNewLogo.svg"
                  class="oxsLogo"
                  alt="logo"
                  srcset=""
               />
            </li>
         </ul>
         <ul class="nav" v-for="(page, i) in mainPageNavs" :key="i">
            <li class="item">
               <p @click="togglePage(page[0])">{{ $t(page[1]) }}</p>
            </li>
         </ul>
      </footer>
   </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import helperValidateEmail from '../Helpers/ValidateEmail-new'

export default {
   components: {
      Carousel,
      Slide,
   },
   name: 'MainPage',
   data() {
      return {
         mainPageNavs: [
            ['isAboutPage', 'about'],
            ['isPrivacyPage', 'privacy'],
            ['isTermsPage', 'terms'],
            ['isPublicComplaintsPage', 'publicComplaintsUnit'],
            ['isCareersPage', 'career'],
         ],
         isApplicationSubmitted: false,
         isResumeUploaded: false,
         section3Contents: null,
         section2Contents: null,
         mainPageContents: null,
         careers: [],
         position: null,
         uplodaingFile: false,
         showModal: false,
         applicationContent: '',
         resume: null,
         hoverIndex: -1,
         togglePages: {
            isMainPage: true,
            isAboutPage: false,
            isTermsPage: false,
            isPrivacyPage: false,
            isPublicComplaintsPage: false,
            isCareersPage: false,
         },
         iosLink: process.env.IOS_LINK,
         androidLink: process.env.ANDROID_LINK,
         negashimLink: process.env.NEGASHIM_LINK,
         msgSentSuccess: false,
         listItems: null,
         contactUsEmail: null,
         windowWidth: 0,
         phoneError: false,
         sendDisabled: false,
         emailError: false,
         nameError: false,
         showError: false,
         info: 'none',
         reason: '',
         name: '',
         email: '',
         phone: '',
         required: ['name', 'email', 'phone', 'info'],
         loginEmail: '',
         loginPassword: null,
         showBackToClentTenant: localStorage.manager,
         termsAccepeted: false,
         isMobile: false,

         showList: null,
      }
   },
   methods: {
      validateEmail(email) {
         return helperValidateEmail(email)
      },
      applicationSubmitted() {
         this.isApplicationSubmitted = true
      },
      filterEmptyContents(unfilterContent) {
         let filteredContent = []
         for (let i = 1; i <= Object.keys(unfilterContent).length / 2; i++) {
            if (
               unfilterContent['content' + i] != '' &&
               unfilterContent['content' + i + 'child'] != ''
            ) {
               filteredContent.push({
                  headline: unfilterContent['content' + i],
                  content: unfilterContent['content' + i + 'child'],
               })
            }
         }
         return filteredContent
      },
      async uploadResume(ev) {
         this.isResumeUploaded = false
         this.uplodaingFile = true
         this.resume = ev.target.files[0]
         const ext = this.getFileExtension(this.resume)
         if (!ext) {
            alert('File format not supported or not found')
            this.uplodaingFile = false
            return
         }
         setTimeout(() => {
            this.isResumeUploaded = true
            this.uplodaingFile = false
         }, 1000)
      },
      async sendResume() {
         const ext = this.getFileExtension(this.resume)

         if (!ext) {
            alert('File format not supported or not found')
            return
         }

         this.darkScreen('on', '#applicSubModal')
         this.isApplicationSubmitted = true

         let base64Resume = await this.toBase64(this.resume)
         let startIndex = base64Resume.indexOf(',')
         base64Resume = base64Resume.substr(startIndex + 1)

         let formData = new FormData()
         formData.append(
            'messageBody',
            JSON.stringify({
               subject: ' Application for ' + this.position + ' position',
               from: '',
               replyTo: '',
               to: `${process.env.CAREERS_MAIL}`,
               cc: '',
               html: this.applicationContent,
               attachments: [
                  {
                     filename: `resume.${ext}`,
                     content: base64Resume,
                     type: this.resume.type,
                     disposition: 'attachment',
                  },
               ],
            })
         )

         this.resume = null
         this.applicationContent = ''
         this.position = null
         this.showModal = false

         try {
            await this.$http.post(`api/wordpress/careers`, formData)
         } catch (err) {
            console.log('failed sending the resume', err)
         }
      },
      getFileExtension(resume) {
         if (resume == null) return null

         const startOfExtIndex = resume.name.lastIndexOf('.')
         const ext = resume.name.substr(startOfExtIndex + 1)
         const allowedDocs = ['pdf', 'doc', 'docx']

         return !allowedDocs.includes(ext) ? null : ext
      },
      getBase64FileType(base64File) {
         let startIdx = base64File.indexOf(':') + 1
         let endIdx = base64File.indexOf(';') - 5

         return base64File.substr(startIdx, endIdx)
      },
      async toBase64(file) {
         return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
         })
      },
      togglePage(page) {
         for (let key of Object.keys(this.togglePages)) {
            if (key == page) this.togglePages[key] = true
            else this.togglePages[key] = false
         }
         window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      checkInterface() {
         this.isMobile =
            /iPhone|iPad/i.test(navigator.userAgent) ||
            /Mobi|Android/i.test(navigator.userAgent)
      },
      startAccessibility() {
         let res = document
            .getElementsByClassName(
               'accessibility_component accessibility_div_wrap'
            )[0]
            .childNodes[0].click()
      },
      openExpendable(i) {
         if (i === this.showList) {
            this.showList = null
            $('#listContent').fadeOut(200)
         } else {
            this.showList = i
            $('#listContent').fadeIn(200)
         }
      },
      goTo(num) {
         let url = ''
         switch (num) {
            case 1:
               url = this.androidLink
               break
            case 2:
               url = this.androidLink
               break
         }
      },
      async requestJoin() {
         if (
            this.info == 'none' ||
            this.phoneError ||
            this.emailError ||
            this.nameError ||
            this.sendDisabled
         ) {
            return (this.showError = true)
         } else {
            this.$ga.event('send', 'event', {
               eventCategory: 'mailto',
               eventAction: 'send',
               eventLabel: `${this.name} - ${this.info}`,
               eventValue: this.email,
            })

            let object = {
               name: `${this.name} - ${this.info}`,
               email: this.email,
               phone: this.phone,
               reason: this.reason,
               sendTo: this.contactUsEmail,
            }
            await this.$http.post('contact', object)
            //    document.getElementById('submit').value = 'פנייתך התקבלה! תודה'
            //    document.getElementById('submit').disabled = false
            //    this.name = ''
            //    this.email = ''
            //    this.phone = ''
            //    this.sendDisabled = true
            //    let thankYouScript = document.createElement('script')
            //    thankYouScript.innerHTML = `!function(f,b,e,v,n,t,s)
            //    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            //    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            //    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            //    n.queue=[];t=b.createElement(e);t.async=!0;
            //    t.src=v;s=b.getElementsByTagName(e)[0];
            //    s.parentNode.insertBefore(t,s)}(window, document,'script',
            //    'https://connect.facebook.net/en_US/fbevents.js');
            //    fbq('init', '285089946226737');
            //    fbq('track', 'PageView');
            //  fbq('track', 'CompleteRegistration');`

            //    let thankYouImage = document.createElement('img')
            //    thankYouImage.style.display = 'none'
            //    thankYouImage.src =
            //       'https://www.facebook.com/tr?id=285089946226737&ev=PageView&noscript=1'
            //    thankYouImage.setAttribute('height', 1)
            //    thankYouImage.setAttribute('width', 1)

            //    let body = document.querySelector('body')
            //    body.appendChild(thankYouScript)
            //    body.appendChild(thankYouImage)
            this.msgSentSuccess = true
            // this.$router.push({ name: 'ThankYou' })
            setTimeout(() => {
               this.sendDisabled = false
            }, 10000)
         }
      },
      login() {
         if (
            !this.loginEmail ||
            this.loginEmail.length === 0 ||
            !this.loginPassword ||
            this.loginPassword.length === 0
         ) {
            alert('יש למלא את הכל השדות בטופס')
            return false
         }

         if (!this.validateEmail(this.loginEmail)) {
            alert('כתובת המייל אינה תקינה')
            return false
         }
         this.$http
            .post('api/user/login', {
               loginEmail: this.loginEmail,
               loginPassword: this.loginPassword,
               termsAccepeted: this.termsAccepeted,
            })
            .then((res) => {
               if (res.data.status === 1 && res.data.data != 0) {
                  localStorage['at'] = res.data.data.token
                  localStorage['u'] = JSON.stringify(res.data.data.user)
                  localStorage['allowedPaths'] = JSON.stringify(
                     res.data.data.user.allowedPaths
                  )
                  location = '/main/stats'
               } else if (res.data.data === 0) {
                  alert('פעולה חד פעמית - נא לאשר את תנאי השימוש')
               }
            })
            .catch((e) => {
               if (e.body.data === 'NOT FOUND') {
                  alert('שם משתמש או סיסמה אינם נכונים')
               }
               if (e.body.data === 'NOT ACTIVE') {
                  alert('משתמש לא פעיל')
               }
               if (e.body.data === '0') {
                  alert('פעולה חד פעמית - נא לאשר את תנאי השימוש')
               }
            })
      },
      resetPassword() {
         if (this.loginEmail.length === 0) {
            alert('אנא הזן כתובת מייל לקבלת הודעת איפוס סיסמה')
         } else {
            this.$http
               .get(`api/user/resetPassword/${this.loginEmail}`)
               .then((res) => {
                  if (res.data.data === 'no user') {
                     alert('כתובת המייל שהוזנה לא קיימת במערכת.')
                  } else {
                     alert('הודעת איפוס סיסמה נשלחה למייל שהוזן.')
                  }
               })
         }
      },
      darkScreen(mode, id) {
         if (mode == 'on') {
            $('#dark').fadeIn(200)
            if (id === '#login-window')
               $('#login-window').css('display', 'grid')
            $(id).show()
            this.$refs.email.focus()
            setTimeout(() => {
               $(id).addClass('loginOn')
            }, 10)
         } else {
            $('#dark').fadeOut(200)
            $('#login-window').removeClass('loginOn')
            //$(id).css('display', 'none')
            setTimeout(() => {
               if (id == 'all') {
                  $('#login-window').hide()
                  $('#applicSubModal').hide()
               } else $(id).hide()
            }, 210)
         }
      },
      goToContact() {
         window.scrollTo({ top: 1840, behavior: 'smooth' })
      },
   },
   computed: {
      isSendDisabled() {
         return this.sendDisabled
      },
   },
   beforeCreate() {
      let recaptchaScript = document.createElement('script')
      Object.assign(recaptchaScript, {
         src: 'https://www.negishim.com/accessibility/accessibility_pro_group255.js',
      })
      document.head.appendChild(recaptchaScript)
      $('<style>')
         .text('.btn_accessibility {display:none !important}')
         .appendTo(document.head)
      // $('<style>')
      //    .text('.btn_accessibility {left:-90vw !important}')
      //    .appendTo(document.head)
   },
   async created() {
      this.checkInterface()
      this.windowWidth = window.innerWidth
      window.addEventListener('keydown', (e) => {
         if (e.keyCode == 27) this.darkScreen('off', 'all')
      })
      window.addEventListener('resize', () => {
         this.windowWidth = window.innerWidth
      })
      let res, mainPageContents, contents
      try {
         res = await this.$http.get('getContactEmail')
         mainPageContents = await this.$http.get(process.env.WP_CONTENTS + 'pagecontents')
         contents = await this.$http.get(process.env.WP_CONTENTS + 'contents')
      } catch (err) {
         console.log('Error', err)
      }

      this.mainPageContents = mainPageContents.body[0].acf
      this.section2Contents = contents.body[2].acf
      this.section3Contents = contents.body[1].acf
      this.careers = this.filterEmptyContents(contents.body[0].acf)
      this.listItems = this.filterEmptyContents(contents.body[2].acf)
      this.contactUsEmail = res.data.data[0].contactUsEmail[0]

      const hash = location.hash.substr(1)
      switch (hash) {
         case 'about':
            this.togglePage('isAboutPage')
            break
         case 'privacy':
            this.togglePage('isPrivacyPage')
            break
         case 'terms':
            this.togglePage('isTermsPage')
            break
         case 'careers':
            this.togglePage('isCareersPage')
            break
         case 'publicComplaintsUnit':
            this.togglePage('isPublicComplaintsPage')
            break
      }
   },
   watch: {
      $route() {
         window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      phone() {
         var re = /^\d+$/
         this.phoneError = !re.test(this.phone)
      },
      email() {
         var re =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         this.emailError = !re.test(this.email)
      },
      name() {
         this.nameError = !this.name || (this.name && !this.name.length > 0)
      },
      showModal() {
         if (!this.showModal) {
            this.isResumeUploaded = false
            this.resume = null
            $('body').css('position', 'relative')
         } else {
            $('body').css('position', 'fixed')
         }
      },
   },
}
</script>
<style lang="less" scoped>
@import '../assets/main.css';
@import '../assets/css/landing.less';
@background: #f4f4f4;
@blue-dark: #151c46;
@grey-light: #d6d6d6;
@blue: #151c46;
@grey: #efefef;
@orange: #ff6813;
@red: #cc3300;
@grey-dark: #45434b;
@purple: #222b66;
@grey-medium: #ccc;
@white: #ffffff;
@hover: #eeeeee;
@grey-border: #ccc;
@header: @blue;
@boxShadow: 0;
@border: solid 1px @grey-border;
@bold: 0.3px 0 0 @grey-dark;
@borderBottom: 1px solid rgba(69, 67, 75, 0.21);
@borderBottomHighlight: 1px solid rgba(69, 67, 75, 0.31);
@titleColor: @blue-dark;
@titleBorder: 1px solid @blue;
@gridcolumn:10vw repeat(10, 1fr) 10vw;
@errorBorder: #505db5;

/deep/ h1,
/deep/ h2,
/deep/ h3,
/deep/ p {
   font-family: 'Simpler' !important;
}
/deep/ h1 {
   font-weight: 700;
   font-size: 40px !important;
   color: @blue-dark;
}
.errorBorder {
   border: 2px solid @errorBorder;
}

h2 {
   text-align: center;
}
/deep/ p {
   font-size: 16px !important;
}

/deep/.container {
   box-sizing: border-box;
   font-family: 'Simpler';
   width: 100%;
   background: @white;
}

/deep/.orange {
   color: @orange;
}
/deep/.white {
   color: @white;
}
/deep/.blue {
   .buttonStyle(@blue, @white, transparent);
}

/deep/.normal {
   .buttonStyle(@orange, @white, transparent);
}
/deep/.whiteBackground {
   .buttonStyle(@white, @orange, @orange);
}

/deep/.header {
   .flex-center;
   justify-content: center;
   height: 490px;
   -webkit-box-shadow: -1px -5px 7px -2px rgba(0, 0, 0, 0.37);
   box-shadow: -1px -5px 7px -2px rgba(0, 0, 0, 0.37);
}

#applicSubModal {
   @media screen and (max-device-width: 600px) {
      height: 35vw !important;
      width: 45vw;
      bottom: 100vw;
      right: 27vw;
      padding-top: 10vw;
      h1 {
         display: contents;
         position: inherit !important;
         right: auto !important;
         top: 15vw !important;
      }
      #applSubClose {
         top: 25vw !important;
      }
   }
   position: fixed;
   width: 25vw;
   height: 15vw;
   left: 35vw;
   background-color: #151c46 !important;
   z-index: 999999;
   bottom: 20vw;
   border-radius: 34px;
   h1 {
      color: white;
      font-size: x-large !important;
      font-family: sans-serif !important;
      direction: ltr !important;
      position: absolute;
      top: 5vw;
      right: 3vw;
   }
   #applSubClose {
      display: inline-block;
      cursor: pointer;
      top: 11vw;
      background-color: @orange;
      border-radius: 34px;
      padding: 2px 10px;
      h2 {
         color: white;
      }

      &:hover {
         background-color: white;
         h2 {
            color: @orange;
         }
      }
   }
}

/deep/.firstTab {
   background: @white;
   background-image: url('/static/gfx/homeScreenFirstTab.svg');
   background-repeat: no-repeat;
   display: grid;
   grid-template-columns: @gridcolumn;
   grid-template-rows: repeat(12, 1fr);
   height: 580px;
   background-position: top;
   background-position-y: 45px;
   #textFirstTab {
      grid-column-start: 3;
      grid-column-end: 7;
      grid-row-start: 4;
      p:first-child {
         margin-top: 30px;
      }
   }
}

.secondTab {
   background: @white;
   display: grid;
   grid-template-columns: @gridcolumn;
   grid-template-rows: repeat(12, 10%);
   align-items: center;
   height: 740px;
   @media screen and (min-device-width: 600px) {
      height: 800px;
   }
   #headline {
      p {
         margin-bottom: 30px;
      }
   }
   .tableGrid {
      @media screen and (max-width: 1200px) and (min-device-width: 600px) {
         grid-column-start: 6;
         grid-column-end: 12;
         grid-row-start: 3;
      }

      @media screen and (min-device-width: 600px) {
         bottom: 6vw !important;
         //height: 800px;
      }

      grid-column-start: 7;
      grid-column-end: 10;
      grid-row-start: 3;
   }
   .imageContainer {
      @media screen and (max-width: 1200px) and (min-device-width: 600px) {
         grid-column-start: 2;
         grid-column-end: 4;
         grid-row-start: 5;
      }
      grid-column-start: 4;
      grid-column-end: 7;
      grid-row-start: 5;
   }

   #listContainer {
      table {
         width: 100% !important;
         position: absolute;
         border-spacing: 0 !important;
         td {
            white-space: normal;
         }
      }
      #listContent {
         transition: opacity 0.8s ease-in;
      }
      #list {
         cursor: pointer;
         z-index: 1;
         tr {
            width: 100% !important;
         }
         td {
            background: unset;
            display: flex;
            justify-content: space-between;
            width: 100%;
         }
         img {
            width: 25px;
         }
         height: 85px;
         display: flex;
         justify-content: space-between;
         align-items: center;
      }
   }
}
.seperator {
   border-top: 1px double @grey;
   text-align: center;
   background: @white;
   img {
      top: -35px;
   }
}

/deep/ .carouselTab {
   background: @white;
   height: 440px;
   display: flex;
   justify-content: center;
   align-items: center;
   .carouselImage {
      img {
         max-height: 30vw;
         max-width: 20vw;
      }
   }
}

.phone-num {
   position: absolute;
   left: 50px;
   top: 50px;
   img {
      position: absolute;
      width: 26px;
      top: 5px;
      left: 20px;
   }
}

.buttonStyle(@color, @text, @border ) {
   padding: 15px 30px;
   min-width: max-content;
   height: 42px;
   text-align: center;
   display: block;
   z-index: 5;
   color: @text;
   background: @color !important;
   border-radius: 25px;
   text-align: center;
   border: 1px solid @border;
   outline: 0;
   font-size: 14px;
   line-height: 3px;
   cursor: pointer;
   transition: all 0.3s ease-in;
   box-shadow: 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
      -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
   text-shadow: darken(@color, 2%);

   &:hover {
      background: lighten(@color, 12%) !important;
   }

   &:active {
      box-shadow: inset 1px 1px 3px 0 rgba(15, 15, 15, 0.15),
         inset -1px -1px 3px 0 rgba(255, 255, 255, 0.15);
      background: darken(@color, 10%) !important;
   }
}

ul {
   list-style: none;
}

.career-preview {
   text-align: left;
}

.applicationModalText {
   direction: ltr !important;
}

.thirdTab {
   position: relative;
   background: @blue;
   height: 270px;
}

/deep/.fifthTab {
   height: 464px;
   background: @white;
   .headlines {
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
         font-weight: 700;
         margin-top: 100px;
         font-family: 'Simpler';
      }
      h2 {
         font-weight: 700;
         color: @blue-dark;
         margin: 5px 0;
         font-size: 40px;
         font-family: 'Simpler';
      }
   }
   .appStore {
      img:first-of-type {
         padding: 0 1rem;
      }
      margin-top: 30px;
      display: flex;
      justify-content: center;
   }
   .imageContainer {
      left: 5%;
      cursor: pointer;
      position: absolute;
      transition: all 0.4s;
      &:hover {
         transition: all 0.4s;
         transform: scale(1.1);
      }
   }
}

.flex-center {
   display: flex;
   flex-direction: column;
   align-items: center;
}

@keyframes scroll {
   0% {
      transform: translateX(0);
   }
   100% {
      transform: translateX(calc(-250px * 11));
   }
}
hr {
   border: 1px solid @grey;
}
/deep/ .aboutTab {
   height: 580px;
}
.careersTab {
   height: 420px;
   margin-bottom: 5vw;
}
/deep/ .aboutTab,
.careersTab {
   grid-template-columns: @gridcolumn;
   grid-template-rows: repeat(6, 10%);
   display: grid;
   justify-items: center;
   .textContainer {
      p {
         font-size: 18px;
         line-height: 28px;
      }
      p,
      h1 {
         margin-bottom: 38px;
      }
      width: 546px;
      height: 326px;
      margin-left: 20px;
      grid-column-start: 3;
      grid-column-end: 6;
      grid-row-start: 2;
      grid-row-end: 6;
      display: table;
   }
   .imageContainer {
      img {
         width: 451px;
         height: 512.71px;
         max-width: 49vw;
      }
      grid-column-start: 7;
      grid-column-end: 11;
      grid-row-start: 2;
      grid-row-end: 6;
   }
}

/deep/ .aboutTab {
   .textContainer {
      @media screen and (min-device-width: 1150px) {
         right: 20vw;
      }
   }
}

.careersTab {
   .textContainer {
      white-space: pre-line;
   }
}

.uploading-file-image {
   position: absolute;
   top: 15vw;
   right: 50%;
}

/deep/ .termsPage,
/deep/ .privacyPage {
   grid-template-rows: repeat(6, 10%);
   display: grid;
   justify-items: center;
   margin: 80px 100px;
   .textContainer {
      h1 {
         margin-bottom: 20px;
      }
      p {
         margin-bottom: 38px;
         margin-left: 100px;
      }
      grid-column-start: 3;
      grid-column-end: 12;
   }
}

.connectTab {
   background: @blue;
   height: 650px;
   display: flex;
   justify-content: center;
   align-items: center;
   .connect {
      grid-template-columns: @gridcolumn;
      grid-template-rows: repeat(12, 10%);
      display: grid;
      align-items: center;
      bottom: 2vw;
      .headline {
         @media screen and (max-width: 1200px) and (min-device-width: 600px) {
            grid-column-start: 3;
            grid-column-end: 11;
            grid-row-start: 1;
            grid-row-end: 3;
            white-space: nowrap;
         }
         grid-column-start: 4;
         grid-column-end: 11;
         grid-row-start: 1;
         display: flex;
         justify-content: center;
         flex-direction: column;
         align-items: center;
         p {
            color: @orange;
         }
         h2 {
            color: @white;
            font-weight: 700;
            font-size: 40px !important;
         }
      }
      .connectForm {
         @media screen and (max-width: 1200px) and (min-device-width: 600px) {
            grid-column-start: 4;
            grid-row-start: 4;
            grid-row-end: 12;
         }
         .connectBtn {
            margin-top: 15px !important;
            width: 45px !important;
            left: 0 !important;
            position: absolute !important;
            bottom: -10% !important;
         }
         grid-column-start: 4;
         grid-column-end: 7;
         grid-row-start: 3;
         grid-row-end: 12;
         input {
            ::placeholder {
               opacity: 1;
               color: white !important;
            }
         }
         select,
         input,
         textarea {
            @media screen and (max-width: 1000px) and (min-device-width: 600px) {
               min-width: 27vw !important;
            }
            color: white !important;
            ::placeholder {
               opacity: 1;
            }
            background: @purple !important;
            padding: 0 10px;
            height: 55px !important;
            border-radius: 2px !important;
            min-width: 15vw !important;
            border: 1px solid @blue;
            outline: 0;
            font-size: 17px;
            line-height: 7px;
         }
         select {
            padding-right: 22px;
         }
         textarea {
            height: 4vw !important;
         }
         input:hover {
            background: #2d3b8a !important;
         }
         textarea:hover {
            background: #2d3b8a !important;
         }
         select:hover {
            background: #2d3b8a !important;
         }
         input:focus {
            border-width: 2px !important;
            border-color: #505db5 !important;
         }
         textarea:focus {
            border-width: 2px !important;
            border-color: #505db5 !important;
         }
         display: flex;
         flex-direction: column;
      }
      .imageContainer {
         @media screen and (max-width: 1200px) and (min-device-width: 600px) {
            img {
               max-width: 300px;
            }
            grid-column-start: 8;
            grid-row-start: 8;
            grid-row-end: 7;
         }

         @media screen and (max-device-width: 600px) {
            img {
               width: 30vw;
               top: 2vw;
            }
         }
         position: absolute;
         grid-column-start: 8;
         grid-column-end: 11;
         grid-row-start: 5;
      }
   }
   .msgSent {
      background-image: url('/static/gfx/msgSentSuccess.svg');
      background-repeat: no-repeat;
      height: 100%;
      width: 100%;
      background-position: center;
      background-position-y: 40%;
   }
}
#dark {
   display: none;
   background: rgba(0, 0, 0, 0.5);
   border: 0px none transparent;
   overflow: hidden;
   margin: 0px;
   padding: 0px;
   -webkit-tap-highlight-color: transparent;
   position: fixed;
   left: 0px;
   top: 0px;
   width: 100%;
   height: 100%;
   transition: opacity 0.3s ease 0s;
   visibility: visible;
   border: none !important;
   -moz-user-select: none;
   -webkit-user-select: none;
   -ms-user-select: none;
   user-select: none;
   -o-user-select: none;
   z-index: 555554;
}

#login-window {
   @media screen and (min-device-width: 600px) {
      width: 60vw !important;
      height: 40vw !important;
      right: 20vw !important;
      top: 5vw !important;
   }
   position: fixed;
   top: 2%;
   width: 90vw;
   height: 45vw;
   border-radius: 5px;
   border: 1px solid @orange;
   padding: 0vw;
   right: 3vw;
   background: #151c46;
   opacity: 0;
   display: none;
   grid-template-columns: repeat(16, 1fr);
   grid-template-rows: repeat(10, 1fr);
   transition: all 0.2s ease-in;
   z-index: 555555;
   box-shadow: 2px 2px 6px 0px rgba(15, 15, 15, 0.15);
   p {
      color: #c5c5c5;
   }
   .termsConfirmation {
      color: #ff6813;
      cursor: pointer;
      margin-right: 0.2vw;
   }
   hr {
      margin: 0px;
      border-top: 1px solid #bec0c2;
   }
   input[type='submit'] {
      text-align: center;
      //font-size: 24px;
      color: #fff;
      padding: 0vw 0.5vw;
      border-radius: 5px;
      background: @orange;
      cursor: pointer;
      transition: all 0.3s;
      border: 0px;
      margin-top: 1.3vw;
      outline: 0;
      &:hover {
         background: lighten(@orange, 10%);
      }
   }

   input:-webkit-autofill,
   input:-webkit-autofill:hover,
   input:-webkit-autofill:focus,
   input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0px 1000px #222b66 inset !important;
      -webkit-text-fill-color: white !important;
   }

   #login-image {
      display: contents;
      width: 20vw;
      height: 45vw;
      img {
         @media screen and (min-device-width: 600px) {
            width: 60% !important;
            height: -webkit-fill-available;
            padding-top: 10vw;
         }
         height: inherit;
         position: absolute;
         bottom: 0vw;
         width: 50vw;
         left: 0vw;
         background: white;
      }
   }

   #login-form {
      display: inline-block;
      width: max-content;
      // padding-top: 40vw;
      // bottom: 37vw;
      // right: 2vw;
      grid-column-start: 2;
      grid-row-start: 2;
      position: unset;
   }

   #loginHelp {
      margin-top: 1vw;
      p {
         font-size: 1vw;
      }
   }

   .login-input {
      @media screen and (max-device-width: 600px) {
         width: 25vw !important;
         height: 4vw !important;
      }
      display: block;
      margin-bottom: 10px;
      background: #222b66 !important;
      color: #ffffff;
      width: 18vw !important;
      height: 3vw !important;
      border-radius: 4px !important;
      border-color: #151c46 !important;
      &:hover {
         background: #2d3b8a !important;
      }

      &::placeholder {
         color: white;
         opacity: 1;
      }
   }

   #login-checkbox {
      margin-left: 0.5vw;
      margin-top: 0.26vw;
   }

   #login-confirmation {
      @media screen and (max-device-width: 600px) {
         p {
            font-size: 1.5vw !important;
         }
      }
      display: flex;
      @media screen and (min-device-width: 600px) {
         p {
            font-size: 0.8vw !important;
         }
      }

      @media screen and (max-width: 1200px) {
         p {
            font-size: 1.5vw !important;
         }
      }
   }

   #login-submit {
      left: 0vw;
      position: absolute;
      input[type='submit'] {
         @media screen and (max-device-width: 600px) {
            font-size: 1.5vw !important;
         }
         border-radius: 34vw;
         font-size: 0.8vw;
         //width: -webkit-fill-available;
         font-family: 'Simpler';
         padding: 0.5vw 1.5vw;
      }
      #newUserLink,
      #forgotPassword {
         @media screen and (max-device-width: 600px) {
            font-size: 1.5vw !important;
         }
         @media screen and (min-device-width: 600px) {
            p {
               font-size: 1.5vw !important;
            }
         }
         @media screen and (max-width: 1200px) {
            font-size: 1.5vw !important;
         }
         display: inline-block;
         font-size: 0.73vw;
         cursor: pointer;
         color: #ff6813;
      }
   }
   #loginTitle {
      @media screen and (max-device-width: 600px) {
         font-size: 4vw !important;
      }
      color: #fff;
      font-weight: 700;
      font-family: Simpler !important;
      font-size: 2vw !important;
      margin-bottom: 50px;
   }

   #login-logo {
      position: absolute;
      bottom: 0;
      right: inherit;
      img {
         @media screen and (min-device-width: 600px) {
            left: 15vw;
         }
         width: 10vw;
      }
   }
}

/deep/ #careerModal {
   hr {
      display: none !important;
   }
   #modalDescription {
      margin-top: 0 !important;
   }
   #candidateComments {
      height: 10vw !important;
      direction: ltr !important;
      margin-top: 1vw !important;
   }
   .modalButton {
      padding: 15px 10px;
      min-width: max-content;
      width: 200px;
      display: block;
      z-index: 5;
      color: #ffffff;
      background: #ff6500 !important;
      border-radius: 34px !important;
      text-align: center;
      border: 0;
      outline: 0;
      font-size: 17px;
      line-height: 7px;
      cursor: pointer;
      transition: all 0.3s ease-in;
   }
   .resumeImage {
      margin-right: 4px;
   }
   #positionCancelButton {
      background: white !important;
      color: black !important;
      border: 1px solid #555555 !important;
   }
   input[type='file'] {
      opacity: 0 !important;
      position: absolute !important;
      z-index: -1 !important;
   }
   #resumeLabel {
      cursor: pointer !important;
      color: #ff6813;
   }
   #positionFormTable {
      margin: 0 !important;
      td {
         text-align: -webkit-center;
      }
   }
   #positionTextTable {
      margin: 0 !important;
      @media screen and (max-device-width: 600px) {
         white-space: initial !important;
         tr {
            td {
               white-space: initial !important;
            }
         }
      }
   }

   #positionImage {
      width: 18vw;
      height: 20vw !important;
      max-height: 35vw !important;
   }
}

.footer {
   display: flex;
   justify-content: center;
   position: relative;
   height: 100px;
   bottom: 0;
   background: @white;
   .nav {
      display: flex;
      align-items: center;
      z-index: 10;
      li {
         height: 50px;
         display: flex;
         align-items: center;
         p,
         img {
            transition: color 250ms cubic-bezier(0.1, 0.2, 0.3, 0.4);
         }
         p:hover {
            color: @orange;
         }
         img:hover {
            color: @orange;
         }
         :first-child {
            margin-right: 80px;
         }
         font-size: 16px;
         color: black;
      }
   }
}

.oxsLogo {
   width: 150px;
   height: 95px;
   margin-right: 0px !important;
}

a {
   text-decoration: none;
   color: @blue;
   &:hover {
      color: black;
   }
}

#error {
   color: @red;
   font-weight: bolder;
   display: none;
}

.redBorder {
   border: 1px solid @red !important;
}

.contactMarginButton {
   margin-bottom: 14px;
}

body {
   margin: 0 !important;
}

/deep/ .criticsText {
   p,
   h1 {
      width: 20vw !important;
   }
}

.mainHeader {
   .loginButton {
      grid-column: 10;
      justify-self: center;
      @media screen and (max-width: 1400px) {
         grid-column-start: 9;
         grid-column-end: 11;
      }
      p {
         overflow: hidden;
      }
      p::after {
         content: '';
         position: absolute;
         bottom: 0;
         left: 0;
         width: 100%;
         height: 0.1em;
         opacity: 0;
         transition: opacity 300ms, transform 300ms;
         background-color: @orange;
      }
      p::after {
         opacity: 1;
         transform: translate3d(-100%, 0, 0);
      }
      p:hover::after,
      p:focus::after {
         transform: translate3d(0, 0, 0);
      }
   }
   position: sticky;
   z-index: 100;
   top: 0;
   background: @white;
   height: 96px;
   display: grid;
   // justify-items: center;
   grid-template-columns: @gridcolumn;
   align-items: center;
   box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
}
.closeList {
   position: absolute;
   bottom: 60px;
   z-index: 0;
   height: 0;
   opacity: 0;
   transition: bottom 0, opacity 0.4s, height 0.4s;
}
.openList {
   opacity: 1;
   bottom: 0;
   transition: opacity 0.6s ease 0.4s, bottom 0.4s 0.4s, height 0.4s 0.2s;
   height: 100px;
   display: block;
}
.orangeBorder {
   transition: all 0.5s ease-out;
   border: 1px solid @orange;
}
.rotate180 {
   transition: all 0.3s;
}
input:focus ~ .floating-label,
input:not(:focus):valid ~ .floating-label {
   font-size: 11px;
   opacity: 1;
}

.inputText {
   font-size: 14px !important;
   width: 200px !important;
   height: 35px !important;
}

.floating-label {
   pointer-events: none;
   left: -10px;
   bottom: 35px;
   right: 30px;
   color: @white;
   transition: 0.2s ease all;
}

input:focus ~ .floating-label {
   bottom: 48px;
   color: #8795f5;
}

.hasInput {
   bottom: 20px;
   color: #8795f5;
}

.careerCards {
   display: grid;
   justify-items: center;
   grid-template-columns: @gridcolumn;
   align-items: center;
   .cards {
      width: 100%;
      grid-column-start: 3;
      grid-column-end: 12;
      margin: 40px 0;
      display: grid;
      grid-template-columns: 3fr 3fr 3fr;
      grid-gap: 20px;
      justify-content: center;
      text-align: center;
      .card {
         border-color: #efefef;
         display: flex;
         width: 480px;
         flex-direction: column;
         justify-content: space-evenly;
         border: 1px solid #efefef;
         box-sizing: border-box;
         height: 262px;
         padding: 20px;
         box-shadow: none;
         -webkit-box-shadow: none;
         button {
            align-self: flex-start;
         }
      }
   }
}
/deep/ .VueCarousel-slide .img-container {
   height: 130px;
   width: 100%;
   float: left;
}
/deep/ .VueCarousel-slide {
   height: 350px;
   display: flex;
   justify-content: space-evenly;
   @media screen and (max-device-width: 600px) {
      height: 520px;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      img {
         max-height: 124px;
      }
      p {
         white-space: pre-line;
      }
   }
}
/deep/ .VueCarousel-wrapper {
   width: 50vw;
}
/deep/ .VueCarousel-dot-container {
   direction: ltr;
   button {
      padding: 5px !important;
   }
}

/deep/ .VueCarousel-inner {
   direction: ltr !important;
}
/deep/ .VueCarousel-dot {
   :first-child {
      position: absolute;
      left: 0;
   }
   background-color: @grey !important;
}
/deep/ .VueCarousel-dot--active {
   background-color: black !important;
}

@media screen and (max-device-width: 600px) {
   input:focus ~ .floating-label,
   input:not(:focus):valid ~ .floating-label {
      top: -35px;
      font-size: 18px;
      opacity: 1;
   }
   h2 {
      font-size: 4.3vmin;
   }
   .inputText,
   p {
      font-size: 3vmin !important;
   }

   .loginButton {
      p {
         min-width: 250px;
      }
   }
   /deep/ .firstTab {
      height: 50vh;
      background-position: bottom;
      #textFirstTab {
         left: 150px;
         p {
            font-size: 28px;
         }
         grid-column-start: 3;
         grid-column-end: 10;
         grid-row-start: 3;
      }
   }
   .secondTab {
      padding: 30px;
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      .tableGrid {
         width: 100%;
      }
      #listContainer {
         table {
            position: initial !important;
            #list {
               height: 5vh;
               h3 {
                  font-size: 28px;
               }
            }
         }
      }
   }
   /deep/ .carouselTab {
      .VueCarousel carouselDescription {
         position: absolute !important;
         top: 0 !important;
         .VueCarousel-wrapper {
            height: 400px !important;
         }
      }
      .criticsText {
         h1,
         p {
            width: 25vw !important;
         }
      }
   }
   .careersTab {
      .textContainer {
         grid-column-start: 3;
         grid-column-end: 11;
         grid-row-start: 2;
         grid-row-end: 3;
      }
      .imageContainer {
         grid-column-start: 4;
         grid-column-end: 9;
         grid-row-start: 6;
      }
   }
   .careerCards {
      grid-template-columns: none;
      .cards {
         box-shadow: none;
         margin: 8vh 0;
         grid-template-columns: none;
         .card {
            align-items: baseline;
            height: 22vh;
            width: 32vh;
            padding: 2rem;
            margin: 2rem;
         }
      }
      h2 {
         font-size: 35px;
      }
   }
   .connectTab {
      display: flex;
      align-items: stretch;
      height: 60vh;
      .headline {
         grid-column-start: 1;
         grid-column-end: 12;
         grid-row-start: 1;
         grid-row-end: 2;
         h2 {
            font-size: 34px;
         }
      }
      .connect {
         margin: 0 25px;
         bottom: 2vw;
         .imageContainer {
            grid-column-start: 8;
            grid-column-end: 11;
            grid-row-start: 9;
         }
         .headline {
            grid-column-start: 1;
            grid-column-end: 12;
            grid-row-start: 1;
            grid-row-end: 3;
         }
         .connectForm {
            grid-column-start: 2;
            grid-column-end: 12;
            grid-row-start: 1;
            .connectBtn {
               margin-top: 15px !important;
               width: 45px !important;
               left: 0 !important;
               position: absolute !important;
               bottom: -10% !important;
            }
            select,
            input,
            textarea {
               width: 75vw !important;
               height: 6vh !important;
            }
            .normal {
               position: initial !important;
               width: 220px;
               height: 60px;
               font-size: 21px;
            }
         }
      }
   }
}

@media screen and (max-device-width: 1150px) {
   /deep/ .aboutTab {
      height: fit-content;
      flex-direction: column;
      align-items: center;
      display: flex;
      .textContainer {
         white-space: pre-line;
         margin: 4rem;
      }
      .imageContainer {
         grid-column-start: 3;
         grid-column-end: 11;
         grid-row-start: 6;
      }
   }
}
.hoverBackground {
   background-color: rgba(241, 135, 42, 0.247) !important;
}

.publicComplaintTab {
   height: auto;
   margin-bottom: 4vw;

   .textContainer {

      h1 {
         margin-bottom: 0;
      }
      .subHeaderText {
         font-size: 22px !important;
         font-family: Assistant,sans-serif !important;
      }

      .publicComplaints {
         display: flex;
         text-align: center;
         gap: 50px;

         @media screen and (max-device-width: 1200px) {
            display: block;
         }

         .publicComplaintsItemRoundBlock {
            display: flex;
            text-align: center;
            gap: 50px;

            .publicComplaintsItemBlock {
               width: fit-content;
               text-align: center;
               width: 220px;

               .publicComplaintsItem {
                  display: flex;
                  text-align: center;
                  justify-content: center;
                  align-items: center;
                  width: 150px;
                  height: 150px;
                  background: transparent;
                  border-radius: 50%;
                  border: 1px solid #ff6813;
                  margin: auto;

                  img {
                     width: 90px;
                  }
               }

               .boxHeader {
                  margin-top: 20px;
                  span {
                     font-size: 20px;
                     margin-top: 20px;
                     font-weight: 700;
                  }
               }

               .boxSubText {
                  span {
                     font-size: 20px;
                  }
               }
            }
         }


         .publicComplaintsItemBox {

            @media screen and (max-device-width: 1200px) {
               margin-top: 20px;
               margin-bottom: 40px;
            }

            .publicComplaintsItem {
               width: 520px;
               padding: 15px;
               border: 1px solid #ff6813;
               border-radius: 8px;

               .boxHeader {
                  text-align: start;
                  span {
                     font-size: 20px;
                     font-weight: 700;
                  }
               }

               .boxSubText {
                  text-align: start;
                  span {
                     font-size: 20px;
                     line-height: 0;
                  }
               }
            }
         }
      }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue